{
  "title": "Migration: from Patreon to Demos",
  "shortTitle": "Migration: from Patreon to Demos",
  "subtitle": "A guide on how current Patreon supporters can migrate to the new platform",
  "author": "Enzo Manuel Mangano",
  "date": "2024-11-21",
  "slug": "patreon-migration",
  "tags": ["thoughts"],
  "featuredImage": "./images/header.webp",
  "series": "thoughts"
}
